import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch } from '../redux-store'
import { ProfileDatasAPI } from '../../api/api'

export interface ProfileIdentifierActionTypes {
    identified: boolean,
    success: number | null,
    error: number | null
}

export interface GetProfileIdentifierTypes {
    phone: string
}

export interface ProfileRemoveDataActionTypes {
    removed: boolean,
    success: number | null,
    error: number | null
}

export interface GetProfileRemoveDataTypes {
    code: number
    sessions: boolean
    addresses: boolean
    likes: boolean
    rates: boolean
}

interface InitialStateTypes {
    identified: boolean,
    removed: boolean,
    
    step: number,
    sessions: boolean,
    addresses: boolean,
    likes: boolean,
    rates: boolean,

    success: number | null,
    error: number | null,

    errorMessage: string | null,
    isFetching: boolean
}

let initialState: InitialStateTypes = {
    identified: false,
    removed: false,
    
    step: 1,
    sessions: false,
    addresses: false,
    likes: false,
    rates: false,

    success: null,
    error: null,

    errorMessage: null,
    isFetching: true
}

export const profileRemoveDataSlice = createSlice({
    name: 'profileRemoveData',
    initialState,
    reducers: {
        identifyStart(state) {
            state.isFetching = true
            state.identified = false
            state.success = null
            state.error = null
            state.errorMessage = null
        },
        identifySuccess(state, action: PayloadAction<ProfileIdentifierActionTypes>) {
            state.isFetching = false
            state.identified = action.payload.identified
            state.success = action.payload.success
            state.error = action.payload.error
        },
        identifyError(state, action: PayloadAction<string>) {
            state.isFetching = false
            state.errorMessage = action.payload
        },

        removeDataStart(state) {
            state.isFetching = true
            state.removed = false
            state.success = null
            state.error = null
            state.errorMessage = null
        },
        removeDataSuccess(state, action: PayloadAction<ProfileRemoveDataActionTypes>) {
            state.isFetching = false
            state.removed = action.payload.removed
            state.success = action.payload.success
            state.error = action.payload.error
        },
        removeDataError(state, action: PayloadAction<string>) {
            state.isFetching = false
            state.errorMessage = action.payload
        },

        setIdentified(state, action: PayloadAction<boolean>) {
            state.identified = action.payload
        },
        setRemoved(state, action: PayloadAction<boolean>) {
            state.removed = action.payload
        },
        setStep(state, action: PayloadAction<number>) {
            state.step = action.payload
        },
        setSessions(state, action: PayloadAction<boolean>) {
            state.sessions = action.payload
        },
        setAddresses(state, action: PayloadAction<boolean>) {
            state.addresses = action.payload
        },
        setLikes(state, action: PayloadAction<boolean>) {
            state.likes = action.payload
        },
        setRates(state, action: PayloadAction<boolean>) {
            state.rates = action.payload
        },
        setSuccess(state, action: PayloadAction<number | null>) {
            state.success = action.payload
        },
        setError(state, action: PayloadAction<number | null>) {
            state.error = action.payload
        },
        setErrorMessage(state, action: PayloadAction<string | null>) {
            state.errorMessage = action.payload
        }
    }
})

export const setIdentified = (identified: boolean) => profileRemoveDataSlice.actions.setIdentified(identified)
export const setRemoved = (removed: boolean) => profileRemoveDataSlice.actions.setRemoved(removed)
export const setStep = (step: number) => profileRemoveDataSlice.actions.setStep(step)
export const setSessions = (sessions: boolean) => profileRemoveDataSlice.actions.setSessions(sessions)
export const setAddresses = (addresses: boolean) => profileRemoveDataSlice.actions.setAddresses(addresses)
export const setLikes = (likes: boolean) => profileRemoveDataSlice.actions.setLikes(likes)
export const setRates = (rates: boolean) => profileRemoveDataSlice.actions.setRates(rates)
export const setSuccess = (success: number | null) => profileRemoveDataSlice.actions.setSuccess(success)
export const setError = (error: number | null) => profileRemoveDataSlice.actions.setError(error)
export const setErrorMessage = (errorMessage: string | null) => profileRemoveDataSlice.actions.setErrorMessage(errorMessage)

// IDENTIFIER
export const identifier = ({
        phone
    }: GetProfileIdentifierTypes
) => async (dispatch: AppDispatch) => {
    try {
        dispatch(profileRemoveDataSlice.actions.identifyStart())
        let response = await ProfileDatasAPI.identifier({
            phone
        })
        dispatch(profileRemoveDataSlice.actions.identifySuccess(response.data))
    } catch (error: any) {
        dispatch(profileRemoveDataSlice.actions.identifyError(error.message))
    }
}

// REMOVE DATA
export const removeData = ({
        code,
        sessions,
        addresses,
        likes,
        rates
    }: GetProfileRemoveDataTypes
) => async (dispatch: AppDispatch) => {
    try {
        dispatch(profileRemoveDataSlice.actions.removeDataStart())
        let response = await ProfileDatasAPI.removeData({
            code,
            sessions,
            addresses,
            likes,
            rates
        })
        dispatch(profileRemoveDataSlice.actions.removeDataSuccess(response.data))
    } catch (error: any) {
        dispatch(profileRemoveDataSlice.actions.removeDataError(error.message))
    }
}

export default profileRemoveDataSlice.reducer